import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Container, Button, ButtonGroup, Card, CardActionArea, CardContent, CardMedia, Typography } from '@material-ui/core';
import { GitHub, Web } from '@material-ui/icons'
export const Projects = () => {
    const classes = useStyles();
    return (
        <Container className={classes.root}>
            <Typography variant="h5" align="left" color="textPrimary" gutterBottom>
Some Things I've Built
                
            </Typography>


            <Grid container spacing={4}>
                {posts.map((post, index) => (
                    <Grid item xs={12} md={6} lg={6} sm={6} key={index}>


                        <CardActionArea component="a" href="#">
                            <Card className={classes.card}>
                                <div className={classes.cardDetails}>
                                    <CardContent>
                                        <Typography component="h2" variant="h5" color="primary">
                                            {post.title}
                                        </Typography>
                                        <Typography variant="subtitle1" color="textSecondary" className={classes.rootText}>
                                            {post.date}
                                        </Typography>
                                        <Typography variant="subtitle1" >
                                            <b>Technology:</b>{post.Technology}
                                        </Typography>
                                        <Typography variant="subtitle1" gutterBottom>
                                            <b>Features:</b>{post.Features}
                                        </Typography>
                                        <ButtonGroup variant="text" color="primary" className={classes.btnGrp}>
                                            <Button startIcon={<GitHub />}>Code</Button>
                                            <Button endIcon={<Web />}>Demo</Button>

                                        </ButtonGroup>


                                    </CardContent>
                                </div>

                                <CardMedia className={classes.cardMedia} image={post.image} title={post.imageTitle} />

                            </Card>
                        </CardActionArea>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
}


const useStyles = makeStyles((theme) => ({
    root:{
        minHeight:'100vh',
        [theme.breakpoints.between('sm', 'md')]: {
            backgroundColor: 'red',
          },
      
    },
    rootText: {
        ...theme.typography.button,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(1),
    },
    btnGrp: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    card: {
        display: 'flex',
        textAlign: 'left'
    },
    cardDetails: {
        flex: 2,
    },
    cardMedia: {
        width: 160,
    },
    markdown: {
        ...theme.typography.body2,
        padding: theme.spacing(3, 0),
    },

}));

const posts = [
    {
        id: Math.floor(Math.random() * 10) + 1,
        title: 'Lading Page',
        description: 'Lorem Ipsum chalo koi bajoi jio vie m aije vka   la jd i qlmad',
        date: new Date().toDateString(),
        image: 'https://source.unsplash.com/random',
        imageTitle: 'pta nh konsi lg',
        Technology: 'React js, Material Ui, Bootstrap.',
        Features: 'Responsive web design, Serverless contact form, Google Analytics Setup'

    },
    {
        id: Math.floor(Math.random() * 10) + 1,
        title: 'Startup Feeds',
        description: 'Lorem Ipsum chalo koi bajoi jio vie m aije vka   la jd i qlmad',
        date: new Date().toDateString(),
        image: 'https://source.unsplash.com/random',
        imageTitle: 'pta nh konsi lg',
        Technology: 'Express Js, Firebase, ReactJs Redux, Material UI',
        Features: 'login, SignUp , Push Notification'

    },
    {
        id: Math.floor(Math.random() * 10) + 1,
        title: 'Rest Api',
        description: 'Lorem Ipsum chalo koi bajoi jio vie m aije vka   la jd i qlmad',
        date: new Date().toDateString(),
        image: 'https://source.unsplash.com/random',
        imageTitle: 'pta nh konsi lg',
        Technology: 'Node.js, Express Js, Passport-jwt',
        Features: 'Authentication, Uploading File, CRUD Operations'

    },
    {
        id: Math.floor(Math.random() * 10) + 1,
        title: 'Portfolio',
        description: 'Lorem Ipsum chalo koi bajoi jio vie m aije vka   la jd i qlmad',
        date: new Date().toDateString(),
        image: 'https://source.unsplash.com/random',
        imageTitle: 'pta nh konsi lg',
        Technology: 'React, Material UI, React-Spring',
        Features: 'Animation, Responsive web design, Serverless Deploy'

    },
]
